<template>
  <div class="login-container pull-height"
       @keyup.enter.native="handleLogin">
    <div>
      <div class="login-main">
        <div class="div_left">
          <div class="title_top">
          <h3>中国化学</h3>
          <div class="title_main">
          <div class="title_line"></div>
          <h3>外事管理平台</h3>
          <span>FOREIGN AFFAIRS MANAGEMENT PLATFORM</span>
          </div>
          </div>
        </div>
        <div class="div_right">
          <div class="login_top">
            <img src="../../../static/img/login/CNCEC.png"/>
          </div>
          <div class="login_center">
            <span style="margin-bottom: 30px;text-align: center;display: block;font-size: 30px;font-weight: 600;color: rgb(38, 65, 112);">登录 | LOGIN</span>
            <div class="login_content">
              <userLogin></userLogin>
            </div>
            <div class="down_chrome">
              <div title="点击下载Google Chrome">
                <span>点击下载:</span>
                <img @click="downloadChrome" src="../../assets/image/down_browser/google-chrome-logo.jpg" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span class="app-footer">版权所有：中国化学工程集团(股份)有限公司 | <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备17025820号-5</a> | 版本号：{{this.versionNumber}}<!-- | 技术支持：北京赛鼎科技有限公司 --></span>
  </div>
</template>
<script>
  import userLogin from "./userlogin";
  import {mapGetters} from "vuex";

  export default {
    name: "login",
    computed: {
      ...mapGetters(["versionNumber"])
    },
    components: {
      userLogin,
    },
    data() {
      return {
        activeName: "user",
      };
    },
    created() {
    },
    methods: {
      //点击下载chrome浏览器
      downloadChrome() {
        window.open('https://www.google.cn/intl/zh-CN/chrome/')
      }
    }
  };
</script>

<style lang="scss">
  @import "../../page/login/index";
</style>
